import React from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Skeleton,
  SkeletonCircle,
  HStack,
} from '@chakra-ui/react';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  hasAvatar?: boolean;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ 
  rows = 5, 
  columns = 4, 
  hasAvatar = false 
}) => {
  return (
    <Box 
      bg="white" 
      borderRadius="lg" 
      boxShadow="sm" 
      border="1px solid" 
      borderColor="gray.200"
      overflow="hidden"
      mb={6}
    >
      <Box overflowX="auto">
        <Table variant="simple" size="md">
          <Thead bg="gray.50">
            <Tr>
              {Array.from({ length: columns }).map((_, index) => (
                <Th key={index}>
                  <Skeleton height="16px" width="80px" />
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <Tr key={rowIndex}>
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <Td key={colIndex}>
                    {hasAvatar && colIndex === 0 ? (
                      <HStack spacing={3}>
                        <SkeletonCircle size="8" />
                        <Box>
                          <Skeleton height="16px" width="120px" mb={1} />
                          <Skeleton height="12px" width="80px" />
                        </Box>
                      </HStack>
                    ) : (
                      <Skeleton height="16px" width={`${Math.random() * 60 + 40}px`} />
                    )}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default TableSkeleton;